import { CardContent } from "@mui/material";
import { forwardRef } from "react";
import { EnhancedSwiperSlideComponent } from "@cc/enhanced-swiper";
import {
  MotionBox,
  MotionCard,
  MotionCardProps,
  MotionImage,
  MotionTypography,
} from "@cc/motion-components";
import { H6_3 } from "@/styles/theme/components/typography.fontvariant";
import { StaticImageData } from "next/image";
import { motion } from "framer-motion";
import {
  bottomToToptextStagger,
  bottomToToptextStaggerChildren,
} from "../animations";
import Link, { LinkProps } from "@cc/link";

interface CompanyCardProps extends Omit<MotionCardProps, "children"> {
  image: StaticImageData | string;
  title: string;
  href: string | LinkProps["href"];
}

export const CompanyInitiativeCard: EnhancedSwiperSlideComponent<CompanyCardProps> =
  forwardRef((props, ref) => {
    const {
      image,
      title,
      href,
      sx,
      index,
      isPrev,
      isActive,
      isVisible,
      isNext,
      ...restProps
    } = props;
    return (
      <Link
        href={href || "#"}
        style={{
          textDecoration: "none",
        }}
      >
        <MotionCard
          elevation={0}
          ref={ref}
          sx={{
            width: { xs: 301, lg: 310 },
            borderRadius: 0,
            bgcolor: "transparent",
            ...sx,
          }}
          {...restProps}
        >
          <CardContent
            sx={{
              p: 0,
              pb: "0 !important",
              "&:hover": {
                img: {
                  transform: "scale(1.1) !important",
                  transition: "all .3s ease-out",
                },
              },
            }}
            component={motion.div}
            variants={bottomToToptextStagger(0.4)}
            initial={"initial"}
            whileInView={"animate"}
            viewport={{ once: true }}
          >
            <MotionBox
              width={1}
              height={{ xs: 301, md: 310 }}
              overflow={"hidden"}
              variants={bottomToToptextStaggerChildren}
            >
              <MotionImage
                src={image}
                alt={title}
                width={310}
                height={310}
                sx={{
                  width: 1,
                  height: { xs: 301, md: 310 },
                  objectFit: "cover",
                }}
              />
            </MotionBox>
            <MotionTypography
              variant="body1"
              fontSize={H6_3}
              mt={2}
              variants={bottomToToptextStaggerChildren}
            >
              {title}
            </MotionTypography>
          </CardContent>
        </MotionCard>
      </Link>
    );
  });

CompanyInitiativeCard.displayName = CompanyInitiativeCard.name;
